/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { LabelName, Required } from '../../../../../utils';

const CustomRadio = withStyles({
  root: {
    '&$checked': {
      color: '#00B6A4',
    },
  },
  checked: {},
})(Radio);

export function MultipleChoice({ data, setData, setError, ind, isRequired, globalStateData }) {
  const [selectedValue, setSelectedValue] = useState(
    globalStateData?.customFormData?.[ind]?.fieldValue ?? '',
  );

  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  useEffect(() => {
    setError(null);

    if (isRequired && !selectedValue) {
      setError(`Field ${ind + 1} is required.`);
      return;
    }

    setData(selectedValue, ind);
  }, [selectedValue]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Grid container style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Grid item>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>
      <Grid item>
        <RadioGroup
          value={selectedValue}
          onChange={handleChange}
          style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
        >
          {data?.multipleChoiceOptions?.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<CustomRadio disabled={isDisabled} />}
              label={option}
            />
          ))}
        </RadioGroup>
      </Grid>
    </Grid>
  );
}

export default MultipleChoice;
